interface IEmptyFactsProps {
  message?: string;
}

export const EmptyFacts = ({
  message = 'No closed months in this window.',
}: IEmptyFactsProps) => (
  <div className="flex h-full min-h-[80px] items-center justify-center px-lg text-center txt-small-regular text-text-tertiary">
    {message}
  </div>
);
